/**
 * Formulários que o usuário pode de fato preencher.
 * A API pode listar formulários sem perguntas; o layout tratava isso como “pendente”
 * e o `/formulario` redirecionava para `/home` — gerando loop e milhares de hits GA/Ads.
 */
export function filterAnswerableForms<
	T extends { form_question?: readonly unknown[] | null },
>(forms: T[] | undefined | null): T[] {
	if (!forms?.length) return [];
	return forms.filter((f) => (f.form_question?.length ?? 0) > 0);
}

/** Lista do colaborador: só formulários ativos na API e com perguntas. */
export function filterEmployeeAvailableForms<T extends Forms.FormWithQuestions>(
	forms: T[] | undefined | null,
): T[] {
	if (!forms?.length) return [];
	return filterAnswerableForms(forms.filter((f) => f.active !== false));
}
